export default __webpack_public_path__ + "static/media/suppliers.d135c8ce.svg";